module.exports = __webpack_public_path__ + "static/media/vision.75d7841e.svg";